import { ConfigurationType } from 'civil-status/constants/configuration-type';
import { ParentVM, SectionVM, Separazione } from 'civil-status/view-models/step-form';

const transformerTipoAccordo = (
  dataSection?: SectionVM,
  subjectAvvoc5?: ParentVM
): string | undefined => {
  if (dataSection?.configuration === ConfigurationType.SEPAR04) {
    return '4';
  }

  if (!Boolean(dataSection?.typeAgreement) && Boolean(subjectAvvoc5?.generality?.lawyerForum)) {
    return undefined;
  }

  return dataSection?.typeAgreement || '1';
};

export const transformerSeparazione = (
  idEvento?: number,
  dataSection?: SectionVM,
  subjectAvvoc1?: ParentVM,
  subjectAvvoc2?: ParentVM,
  subjectAvvoc5?: ParentVM,
  dataDatiGeneraliRiconc?: SectionVM
): Separazione | undefined => {
  if (!(dataSection || subjectAvvoc1 || subjectAvvoc2 || subjectAvvoc5 || dataDatiGeneraliRiconc)) {
    return undefined;
  }

  const tipoAccordo = transformerTipoAccordo(dataSection, subjectAvvoc5);

  return {
    key: {
      idEvento,
    },
    flagAssegnoMantenimento: dataSection
      ? dataSection?.isMaintenanceAllowance
        ? '1'
        : '0'
      : undefined,
    descrizioneDatiAssegnoMantenimento: dataSection?.maintenanceAllowance || undefined,
    flagInGiudizioPendente: dataSection ? (dataSection?.isPendingJudgment ? '1' : '0') : undefined,
    descrizioneAutoritaGiudiziaria: dataSection?.judicialAuthority || undefined,
    flagPresenzaConiuge1: dataSection ? (dataSection?.isHusband ? '1' : '0') : undefined,
    flagPresenzaConiuge2: dataSection ? (dataSection?.isWife ? '1' : '0') : undefined,
    flagPresenzaAvvConiuge1: dataSection ? (dataSection?.isLawyerHusband ? '1' : '0') : undefined,
    flagPresenzaAvvConiuge2: dataSection ? (dataSection?.isLawyerWife ? '1' : '0') : undefined,
    dataEventoMatrimonio: dataSection?.dateMarriage
      ? dataSection?.dateMarriage.toFormat('yyyy-MM-dd')
      : undefined,
    dataConfermaAccordo: dataSection?.dateAgreementConfirmation
      ? dataSection?.dateAgreementConfirmation.toFormat('yyyy-MM-dd')
      : undefined,
    tipoAccordo,
    tipoProvvedimentoSeparazione:
      dataSection?.typeSeparation || dataDatiGeneraliRiconc?.typeSeparation || undefined,
    descrizioneOfficianteEventoMatrimoni: dataSection?.celebratedBy || undefined,
    tipoSeparazioneDivorzio: dataSection?.typeEvent || undefined,
    testoModificaAccordo: dataSection?.templateTranscriptionText || undefined,
    flagAvvocatoUnico: dataSection ? (dataSection?.isLawyerHusbandWife ? '1' : '0') : undefined,
    nomeForoAvvUnico: subjectAvvoc5?.generality?.lawyerForum || undefined,
    nomeForoAvvConiuge1: subjectAvvoc1?.generality?.lawyerForum || undefined,
    nomeForoAvvConiuge2: subjectAvvoc2?.generality?.lawyerForum || undefined,
    tipoSezione: dataSection?.typePersistence || undefined,
  };
};
